// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export const isInteger = (value: string) => {
  return /^\d*$/.test(value);
};
